'use client'

import Layout from 'components/LayoutAppRouter/Layout'
import type { PageProviderServer } from './PageProvider'

/**
 * Client shell: `Layout` + chrome props from `slimmedProps`. Composed under server RSC wrappers
 * (`FeatureFlagProviderServer`, `GraduateProviderServer`, `DTIProviderServer`) in `PageProvider`.
 */
export function PageLayoutClient({ children, pageProps }: PageProviderServer) {
  const isFDRPage = pageProps.siteInfo?.url === 'https://www.freedomdebtrelief.com/'
  const printWebAppSchema = !isFDRPage
  const printLocalBusinessSchema = isFDRPage

  return (
    <Layout
      pageDisclosure={pageProps.pageDisclosure}
      secondaryDisclosures={pageProps.secondaryDisclosures}
      disabledRoutes={pageProps.disabledRoutes}
      disabledElements={pageProps.disabledElements}
      showProgressPage={pageProps.showProgressPage}
      customPhoneData={pageProps.customPhoneData}
      isMobileUA={pageProps.isMobileUA}
      header={pageProps.header ?? undefined}
      footer={pageProps?.footer}
      pageConfig={pageProps?.pageConfig}
      showHeader={!pageProps?.tcbBannerLayout}
      showFooter={!pageProps?.tcbBannerLayout}
      alignContentBottom={pageProps?.tcbBannerLayout}
      consentBanner={pageProps?.achieveConsentBanner?.[0] || []}
      specificHeaderCtaDataFiltered={pageProps.specificHeaderCtaDataFiltered}
      showPhoneNumber={pageProps?.showPhoneNumber}
      siteInfo={pageProps?.siteInfo}
      footerSticky={pageProps?.footerSticky}
      leadId={pageProps?.cookies?.['leadId']}
      printWebAppSchema={printWebAppSchema}
      printLocalBusinessSchema={printLocalBusinessSchema}
      associatedProduct={pageProps?.associatedProduct}
      publicProcessDotEnv={pageProps?.publicProcessDotEnv}
      dynamicStickyNav={pageProps?.dynamicStickyNav}
      predefinedChatPrompts={pageProps?.predefinedChatPrompts}
      phoneData={pageProps?.computedPhoneData}
    >
      {children}
    </Layout>
  )
}
